import { FilterRuleDefinitionDTO } from "../DTO/filterRuleDefinitionDTO";

export class FilterRuleDefinition{
    public id!: number;
    public name!: string;
    public description!: string;
    public inputDataType!: string;
    public parameterCount!: number;
    public parameterLabels!: string;

    public static mapFromDTO(param:FilterRuleDefinitionDTO):FilterRuleDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new FilterRuleDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.description = param.description;
            obj.inputDataType = param.inputDataType;
            obj.parameterCount = param.parameterCount;
            obj.parameterLabels = param.parameterLabels;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:FilterRuleDefinition):FilterRuleDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new FilterRuleDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.description = param.description;
            dto.inputDataType = param.inputDataType;
            dto.parameterCount = param.parameterCount;
            dto.parameterLabels = param.parameterLabels;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    public getParameterLabel(index:number):{label:string, maxLength:number} | undefined {
        if(this.parameterLabels){
            let labelArray = this.parameterLabels.split(',');
            if(index < labelArray.length){
                let labelItemArray=labelArray[index].split(':');
                let maxLength= (labelItemArray.length>1)?labelItemArray[1]:50;
                return {label:labelItemArray[0], maxLength:isNaN(Number(maxLength))?50:Number(maxLength)}; //our default maxLength for Parameters is 50
            }
            else return undefined;
        }
        else return undefined;
    }

    get showDateToggles(){
        return this.inputDataType=='DATE' && this.id!=8 && this.id!=12 && this.id!=15 && this.id!=16; //Id 8 just checks for empty date, Id 12 and 15 expect a numeric input, 16 expects no input
    }
  
    get showNumericInput(){
        return (this.inputDataType=='NUMERIC' && this.id!=4) || this.id==12 || this.id==15;
    }
  
    get showTextInput(){
        return this.id!=1 && !this.showNumericInput && !this.showDateToggles;
    }

    get isCompareDate(){
        return this.id==9 || this.id==10 || this.id==11;
    }
}